import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=ff3b7272&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=ff3b7272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3b7272",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff3b7272')) {
      api.createRecord('ff3b7272', component.options)
    } else {
      api.reload('ff3b7272', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=ff3b7272&scoped=true&", function () {
      api.rerender('ff3b7272', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22a5O1PPu9upJ/JS/comp/CookieBox.vue"
export default component.exports